import { Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Subscription } from 'rxjs/Subscription'
import { FormControl, FormGroup } from '@angular/forms'
import { AdministrationModel } from '../../../models/administration.model'
import { fuseAnimations } from '../../../../core/animations'
import 'rxjs/add/operator/distinctUntilChanged'
import 'rxjs/add/operator/debounceTime'
import { AdministrationService } from '../../../services/administration.service'
import { dutch } from '../i18n/nl'
import { english } from '../i18n/en'
import { FuseTranslationLoaderService } from '../../../../core/services/translation-loader.service'
import { SettingsModel } from '../../../models/settings.model'
import { SettingsService } from '../../../services/settings.service'
import { AdministrationManDownDialogComponent } from './administration-man-down-dialog/administration-man-down-dialog.component'
import * as moment from 'moment'
import { MatDialog } from '@angular/material'

@Component({
  selector: 'app-administration',
  templateUrl: './administration-details.component.html',
  styleUrls: ['./administration-details.component.scss'],
  animations: fuseAnimations,
})
export class AdministrationDetailsComponent implements OnInit, OnDestroy {
  searchInput: FormControl
  administration: AdministrationModel
  adminSettings: SettingsModel
  dialogRef: any
  onSearchChanged: Subscription
  loading = false
  administrationId: number = undefined
  view: string

  constructor(
    private administrationService: AdministrationService,
    private translationLoader: FuseTranslationLoaderService,
    private _settingsService: SettingsService,
    private route: ActivatedRoute,
    private _router: Router,
    public dialog: MatDialog,
  ) {
    this.translationLoader.loadTranslations(english, dutch)
    this.searchInput = new FormControl('')
    this.administrationId = this.route.snapshot.params['administrationId']
    this.view = this.route.snapshot.params['view']
  }

  ngOnInit() {
    this.administration = this.route.snapshot.data.administration

    this.onSearchChanged = this.searchInput.valueChanges
      .debounceTime(500)
      .distinctUntilChanged()
      .do(searchText => {
        this._router.navigate(['/administrations/search/' + searchText])
      })
      .subscribe()
  }

  ngOnDestroy() {
    // this.onSearchChanged.unsubscribe();
  }

  public goToList() {
    this._router.navigate(['/administrations'])
  }

  /**
   * Toggle deleted.
   *
   * @param event
   */
  public toggleDeleted(event) {
    this.dialogRef = this.dialog.open(AdministrationManDownDialogComponent, {
      panelClass: 'contact-form-dialog',
      data: {
        administration: this.administration,
      },
    })

    this.dialogRef.afterClosed().subscribe((response: FormGroup) => {
      if (!response) {
        return
      }
      this.administration.stopped_at = moment(response.getRawValue().stopped_at).format('YYYY-MM-DD')
      this.administrationService.manDown(this.administration).subscribe()
    })
  }

  public remoteLogin(event) {
    this.administrationService.remoteLogin(this.administration)
    event.stopPropagation()
  }

  public changeView(view: any): void {
    this.view = view
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/administrations/administration-details/administration-details.component.ts